import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0A0A0A] text-white border-t border-[#F2C500]/30">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] mt-2">{META.tag} · est. {META.est}</p>
          <p className="text-sm text-white/55 mt-5 leading-[1.7] max-w-md">A small strength-and-conditioning gym in TriBeCa. Three coaches. 2,400 sq ft. Heavy bars and a single board to write your name on.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] mb-3">Floor hours</p>
          <table className="w-full text-sm"><tbody>
            {[['Mon — Fri', '06:00 — 21:00'], ['Saturday', '08:00 — 14:00'], ['Sunday', 'Open Floor only · 09:00-13:00']].map(([d, h]) => (<tr key={d} className="border-b border-white/10"><td className="py-1.5 text-white/55">{d}</td><td className="py-1.5 text-right font-mono text-[11px]">{h}</td></tr>))}
          </tbody></table>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500] mb-3">Address</p>
          <p className="text-sm text-white/85 leading-relaxed">142 Reade Street<br />TriBeCa · NY 10013</p>
          <p className="font-mono text-[11px] text-white/55 mt-2">+1 212 555 0184</p>
        </div>
      </div>
      <div className="border-t border-white/15 px-6 lg:px-12 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
        <span>© 2026 {META.brand} S&C · A coached strength gym</span>
        <div className="flex gap-6"><button onClick={() => setPage('coaches')} className="hover:text-[#F2C500]">Coaches</button><a href="#" className="hover:text-[#F2C500]">Privacy</a></div>
      </div>
    </footer>
  );
}
